import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProductDocumentsState {
  documentToDistribute: unknown[];
}

const initialState: ProductDocumentsState = {
  documentToDistribute: [],
};

const productDocumentSlice = createSlice({
  name: 'productDocumentSlice',
  initialState: initialState,
  reducers: {
    setDocumentsToDistribute(state, action: PayloadAction<unknown[]>) {
      state.documentToDistribute = action.payload;
    },
  },
});

export const { setDocumentsToDistribute } = productDocumentSlice.actions;

export default productDocumentSlice.reducer;
